"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LockBadge = LockBadge;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var theme_1 = require("../../theme");
var Icons_1 = require("../Icons");
function LockBadge(_a) {
    var sx = _a.sx;
    var p = (0, theme_1.useV2Palette)();
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: __spreadArray([
            {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 20,
                height: 20,
                borderRadius: '2px',
                bgcolor: p.background.info.subtle,
            }
        ], (Array.isArray(sx) ? sx : [sx]), true), children: (0, jsx_runtime_1.jsx)(Icons_1.LockIcon, { sx: { fontSize: 12, color: p.foreground.semantic.info } }) }));
}
